<template>
  <div>
    <el-table
      ref="list"
      border
      :data="tableData"
      style="width: 100%"
      @row-click="rowClick"
      show-summary
      :summary-method="getSummaries"
    >
    
      <insert-row @on-insert="onInsert" />
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="BarCode" label="条码">
        <template slot-scope="{ row }">
          <span>{{ row.BarCode }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="GoodsName" label="商品名称" /> -->
      <el-table-column label="商品名称" min-width="150px" prop="GoodsName">
        <template slot-scope="{ row }">
          <account-select
            v-model="row.GoodsName"
            :source="DAccount"
            @select="onSelect($event, row)"
            v-if="!readonly && info.SupplierId"
            :pageSize="pageParams.pageSize"
            :pageIndex="pageParams.pageIndex"
            :listTotal="listTotal"
            @currentPage="currentPage($event, row)"
            @click.native="resetFun"
            @inputText="inputText($event, row)"
            :pageType="true"
          />
          <span v-else>{{ info.SupplierId ? row.GoodsName : '请先选择客户' }}</span>
          <!-- <span v-else>{{ row.GoodsName }}</span> -->
        </template>
      </el-table-column>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="Quantity1" label="辅单位数量1" width="90px">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Quantity1"
            type="number"
            @input="changeNum(row)"
            @blur="onBlur(row,'Quantity1')"
            @focus="onFocus(row,'Quantity1')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.Quantity1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId1" label="辅单位1">
        <template slot-scope="{ row }">
          <el-select
            v-if="row.Units && row.Units.length"
            v-model="row.UnitId1"
            :placeholder="readonly?'':'请选择'"
            :disabled="readonly"
            @change="unitChange(row,'1')"
          >
            <el-option
              v-for="(item,index) in row.Units"
              :key="index"
              :label="item.UnitName"
              :value="item.UnitId"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="Offer" label="报价">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Offer"
            type="number"
            @input="rateChange(row)"
            @blur="onBlur(row,'Offer')"
            @focus="onFocus(row,'Offer')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ $commonJs.getThousandNum(row.Offer) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="单价">
        <template slot-scope="{ row }">{{$commonJs.getThousandNum(row.Price)}}</template>
      </el-table-column>
      <el-table-column prop="NoTaxAmount" label="不含税金额" width="90px">
        <template slot-scope="{ row }">{{$commonJs.getThousandNum(row.NoTaxAmount)}}</template>
      </el-table-column>
      <el-table-column prop="Quantity" label="主单位数量" width="90px">
        <template slot-scope="{ row }">
          <span>{{ row.Quantity }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId" label="主单位">
        <template slot-scope="{ row }">
          <el-select
            v-if="row.Units && row.Units.length"
            v-model="row.UnitId"
            :placeholder="readonly?'':'请选择'"
            :disabled="true"
          >
            <el-option
              v-for="(item,index) in row.Units"
              :key="index"
              :label="item.UnitName"
              :value="item.UnitId"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity2" label="辅单位数量2" width="90px">
        <template slot-scope="{ row }">
          <span>{{ row.Quantity2 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UnitId2" label="辅单位2">
        <template slot-scope="{ row }">
          <el-select
            v-if="row.Units && row.Units.length"
            v-model="row.UnitId2"
            :placeholder="readonly?'':'请选择'"
            :disabled="readonly"
            @change="unitChange(row,'2')"
          >
            <el-option
              v-for="(item,index) in row.Units"
              :key="index"
              :label="item.UnitName"
              :value="item.UnitId"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      
      <el-table-column prop="Discount" label="折扣%">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Discount"
            type="number"
            @input="disChange(row)"
            @blur="onBlur(row,'Discount')"
            @focus="onFocus(row,'Discount')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.Discount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="NoTaxPrice" label="无税单价" v-if="disposeTax == 1">
        <template slot-scope="{ row }">{{$commonJs.getThousandNum(row.NoTaxPrice)}}</template>
      </el-table-column>
      <el-table-column prop="TaxRate" label="税率/%" v-if="disposeTax == 1">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.TaxRate"
            type="number"
            @input="rateChange(row)"
            @blur="onBlur(row,'TaxRate')"
            @focus="onFocus(row,'TaxRate')"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{ row.TaxRate }}</span>
        </template>
      </el-table-column>
     
      <!-- <template slot-scope="{ row }">
          <el-input v-model="row.Price" type="number" @input="rateChange(row)" v-if="!readonly"></el-input>
          <span v-else>{{row.Price}}</span>
      </template>-->
      <!-- </el-table-column> -->
      <el-table-column prop="TaxAmount" label="税额" v-if="disposeTax == 1">
        <template slot-scope="{ row }">{{$commonJs.getThousandNum(row.TaxAmount)}}</template>
      </el-table-column>
      <el-table-column prop="Amount" label="含税金额">
        <template slot-scope="{ row }">{{$commonJs.getThousandNum(row.Amount)}}</template>
      </el-table-column>
     
      <!-- <el-table-column prop="num" label="包装数量" /> -->
      <el-table-column label="操作" align="center" width="130px" v-if="!readonly" fixed="right">
        <template slot-scope="scope">
          <!-- <el-link icon="el-icon-plus"  style="margin-right:10px;" @click="interpolate(scope.row,scope.$index)" :underline="false">插行</el-link> -->
          <el-link
            icon="el-icon-copy-document"
            style="margin-right:10px;"
            @click.stop="copy(scope.row, scope.$index)"
            :underline="false"
          >复制</el-link>
          <el-link
            icon="el-icon-delete"
            @click.stop="del(scope.row, scope.$index)"
            :underline="false"
          >删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider> 
  </div>
</template>
<script>
import accountSelect from "@/components/sales/business/select";
export default {
  props: {
    info: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    disposeTax: {
      type: [String, Number],
      default: "",
    },
  },
  components: {
    accountSelect,
  },
  data() {
    return {
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      tableData: [],
      tableDel: [],
      multi: require("@/api/goods/multiUnit").default,
      sApi: require("@/api/goods/goods").default,
      api: require("@/api/sale/stInDoc").default,
      saleApi: require("@/api/sale/sales").default,
      account_api: require("@/api/goods/goods").default,
      PriAdjustGoodsList: [],
      DAccount: [],
      initDAccount: [],
      initTotal: 0,
    };
  },
  mounted() {
    this.account_api
      .list({ Status: 1, pageIndex: 1, pageSize: 7 })
      .then((res) => {
        if (res.Code == 0)
          (this.DAccount = res.Data),
            (this.initDAccount = res.Data),
            (this.initTotal = res.Count);
      });
  },
  methods: {
    onInsert(e){
      let {type, index} = e;

      this.interpolate(null, index, type)
      
    },
    unitChange(row, name) {
      row.Units.forEach((e) => {
        if (e.UnitId == row["UnitId" + name]) {
          row["Rate" + name] = e.Rate;
        }
      });
      this.count(row);
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage(val, row) {
      this.pageParams.pageIndex = val;
      let GoodsName = row.GoodsName;
      this.account_api
        .list({ Status: 1, pageIndex: val, pageSize: 7, GoodsName })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
      
    },
    inputText(text,row) {
      if (text == row.GoodsName) {
        //console.log("相同", text);
        return;
      }
      row.GoodsName = text;

      this.account_api
        .list({ Status: 1, pageIndex: 1, pageSize: 7, GoodsName: text })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const fieldsToSum = ['Quantity1', 'NoTaxAmount', 'Quantity', 'Quantity2','Amount'];
      const sums = [];
      sums[0] = "合计";
      columns.forEach((column, index) => {
        if (fieldsToSum.includes(column.property)) {
          const values = data.map(item => Number(item[column.property]));
        
          if (!values.every(value => isNaN(value))) {
            const sum = values.reduce((prev, curr) => {
              const value = Number(curr);
              return !isNaN(value) ? prev + value : prev;
            }, 0);
            sums[index] = sum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          } else {
            sums[index] = "0.00";
          }
        } else {
          if (sums[index] === undefined) {
            sums[index] = ""; 
          }
        }
      });
      return sums;
    },
    rowClick(row) {
      if (!this.readonly) {
        var index = this.$refs.list.data.indexOf(row);
        if (index + 1 == this.$refs.list.data.length) {
          //
          this.addGoods();
        }
      }
    },
    onSelect(e, row) {
      if(!this.info.SupplierId){     
        this.$message.error("请选择供应商");   
        
      }
      row.T = row.T == 0 ? 0 : 1;
      row.OrderGoodsId = 0;
      row.OrderId = this.info.OrderId || 0;
      row.BarCode = e.BarCode;
      row.GoodsName = e.GoodsName;
      row.GoodsId = e.GoodsId;
      row.Model = e.Model || "";
      row.UnitId = e.UnitId || 0;
      // row.UnitName = e.MainUnitName || "";
      row.Quantity = 0;
      row.Quantity1 = 0;
      row.Quantity2 = 0;
      row.BatchNo = e.BatchNo || "";
      row.Offer = e.WholesalePrice || 0;
      row.Discount = 100;
      row.Price = e.WholesalePrice || 0;
      row.ExistQuantity = e.ExistQuantity || 0;
      row.AvailableQuantity = e.AvailableQuantity || 0;
      row.TaxRate = 0;
      row.TaxAmount = 0;
      row.Amount = 0;
      row.NoTaxPrice;
      row.NoTaxAmount = 0;
      row.PromotionType = 0;
      row.PromotionId = 0;
      row.ReferenceCost = e.ReferenceCost || 0;
      row.GrossProfit = 0;
      row.Remark = e.Remark || "";
      row.Thumbnail = "";
      row.OutQuantity = 0;
      row.AddTime = this.info.DocDate || today;
      this.sApi//获取客户报价，历史价
        .getGoodsOffer({GoodsId:e.GoodsId,TradeUnitId:this.info.SupplierId,DocType:3})
        .then((res)=>{
          row.Offer = res.Data;
          row.Price = res.Data;
        })
      this.multi.list({ GoodsId: e.GoodsId }).then((res) => {
        row.Units = res.Data;
        res.Data.forEach((e) => {
          if (e.IsMain) {
            row.UnitId = e.UnitId;
            row.UnitId1 = e.UnitId;
            row.Rate1 = e.Rate;
          }
          if (row.UnitId2 == e.UnitId) {
            row.Rate2 = e.Rate;
          }
        });
      });
    },
    getData() {
      this.tableData = [];
      this.info.Goods.forEach((e) => {
        // if (e.UnitId == 0) {
        //   e.UnitId = null;
        // }
        // if (e.UnitId1 == 0) {
        //   e.UnitId1 = null;
        // }
        if (e.UnitId2 == 0) {
          e.UnitId2 = null;
        }
        e.T = null;
        e.Units.forEach((v) => {
          if (v.IsMain) {
            e.UnitId = v.UnitId;
            e.UnitId1 = v.UnitId;
            e.Rate1 = v.Rate;
          }
          if (e.UnitId2 == v.UnitId) {
            e.Rate2 = v.Rate;
          }
        });
      });
      this.tableData = this.info.Goods;

      // this.saleApi.getGoodsList(this.info.OrderId).then((res) => {
      //   this.tableData = res.Data;
      // });
    },
    del(row, index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.T !== 0) {
          row.T = 2;
          this.tableDel.push(row);
        }
        if (this.tableData.length == 1) {
          this.tableData.splice(index, 1);
          this.addGoods();
        } else {
          this.tableData.splice(index, 1);
        }
        this.subTable();
      });
    },
    interpolate(row, index,type=""){
      let goods = {
        T: 0,
        OrderGoodsId: 0,
        OrderId: 0,
        BarCode: "",
        GoodsName: "",
        GoodsId: "",
        Model: "",
        UnitId: 0,
        // UnitName: "",
        Quantity: 0,
        Quantity1: 0,
        Quantity2: 0,
        BatchNo: "",
        Offer: 0,
        Discount: 100,
        Price: 0,
        NoTaxPrice: 0,
        ExistQuantity: 0,
        AvailableQuantity: 0,
        TaxRate: 0,
        TaxAmount: 0,
        Amount: 0,
        NoTaxPrice: 0,
        NoTaxAmount: 0,
        PromotionType: 0,
        PromotionId: 0,
        ReferenceCost: 0,
        GrossProfit: 0,
        Remark: "",
        Thumbnail: "",
        OutQuantity: 0,
        AddTime: "",
        WholesalePrice: "",
        UnitId: "",
        UnitId1: "",
        UnitId2: "",
      };
      if(type=="down"){
        index=index+1;
      }
      this.tableData.splice(index, 0, goods);
      let copy = JSON.parse(JSON.stringify(this.tableData));
      this.tableData = [];
      this.$nextTick(() => {
        copy.forEach((x,index)=>{
          if(x.OrderGoodsId>0){x.T=1}
          x.Sn=index+1;
        })
        this.tableData = copy;
      })
      //console.log("this.tableData",this.tableData)
 
    },
    copy(row, index) {
      this.tableData.splice(index, 0, { ...row });
      this.tableData[index].OrderGoodsId = 0;
      this.tableData[index].T = 0;
      this.tableData.forEach((x,index)=>{
        if(x.OrderGoodsId>0){x.T=1}
          x.Sn=index+1;
        })
      this.subTable();
    },
    addGoods() {
      let goods = {
        T: 0,
        OrderGoodsId: 0,
        OrderId: 0,
        BarCode: "",
        GoodsName: "",
        GoodsId: "",
        Model: "",
        UnitId: 0,
        // UnitName: "",
        Quantity: 0,
        Quantity1: 0,
        Quantity2: 0,
        BatchNo: "",
        Offer: 0,
        Discount: 100,
        Price: 0,
        NoTaxPrice: 0,
        ExistQuantity: 0,
        AvailableQuantity: 0,
        TaxRate: 0,
        TaxAmount: 0,
        Amount: 0,
        NoTaxPrice: 0,
        NoTaxAmount: 0,
        PromotionType: 0,
        PromotionId: 0,
        ReferenceCost: 0,
        GrossProfit: 0,
        Remark: "",
        Thumbnail: "",
        OutQuantity: 0,
        AddTime: "",
        WholesalePrice: "",
        UnitId: "",
        UnitId1: "",
        UnitId2: "",
      };
      this.tableData.push(goods);
      this.tableData.forEach((x,index)=>{
          x.Sn=index+1;
        })
    },
    setGoods(e) {
      console.log("e", JSON.parse(JSON.stringify(e)));
      let date = new Date();
      let today = this.$commonJs.getToday();
      // var params = { GoodsIds: [e.GoodsId], AdjustDate: this.info.DocDate };
      // this.sApi.getGoodsPrice(params).then((res) => {        
        let goods = {
          T: 0,
          OrderGoodsId: 0,
          OrderId: this.info.OrderId || 0,
          BarCode: e.BarCode,
          GoodsName: e.GoodsName,
          GoodsId: e.GoodsId,
          Model: e.Model || "",
          UnitId: e.UnitId,
          UnitId1: e.UnitId1,
          UnitId2: e.UnitId2,
          Rate1: 0,
          Rate2: 0,
          // UnitName: e.MainUnitName || "",
          Quantity: e.Quantity,
          Quantity1: e.Quantity,
          Quantity2: null,
          BatchNo: e.BatchNo || "",
          Offer: e.WholesalePrice || 0,
          Discount: 100,
          Price: e.WholesalePrice || 0,
          NoTaxPrice: e.WholesalePrice || 0,
          ExistQuantity: e.ExistQuantity || 0,
          AvailableQuantity: e.AvailableQuantity || 0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost: e.ReferenceCost || 0,
          GrossProfit: 0,
          Remark: e.Remark || "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: this.info.DocDate || today,
          WholesalePrice: e.WholesalePrice,
          Units: [],
        };

        this.sApi//获取客户报价，历史价
        .getGoodsOffer({GoodsId:e.GoodsId,TradeUnitId:this.info.SupplierId,DocType:3})
        .then((res)=>{
          goods.Offer = res.Data;
          goods.Price = res.Data;
        //})

        this.multi.list({ GoodsId: e.GoodsId }).then((res) => {
          goods.Units = res.Data;
          res.Data.forEach((x) => {
            if (x.IsMain) {
              goods.UnitId = x.UnitId;
              goods.UnitId1 = x.UnitId;
              goods.Rate1 = x.Rate;
            }
            if (goods.UnitId2 == x.UnitId) {
              goods.Rate2 = x.Rate;
            }
          });
        });
        console.log("goods", JSON.parse(JSON.stringify(goods)));
        this.tableData.push(goods);
        this.subTable();
      });
    },
    changeNum(row) {
      // row.Quantity = Math.floor(row.Quantity);
      this.count(row);
    },
    rateChange(row) {
      this.count(row);
    },
    disChange(row) {
      this.count(row);
    },
    count(row) {
      let price = row.Price ? Number(row.Price) : 0;
      let dis = row.Discount > 0 ? Number(row.Discount) : 100;
      let qua = row.Quantity1 ? Number(row.Quantity1) : 0;
      let rate = row.TaxRate ? Number(row.TaxRate) : 0;
      let ref = row.ReferenceCost ? Number(row.ReferenceCost) : 0;
      if (row.T !== 0) {
        row.T = 1;
      }
      if (this.disposeTax == 1) {
        row.Price = dis
          ? (row.Offer * (dis / 100) * (1 + rate / 100)).toFixed(2)
          : (row.Offer * (1 + rate / 100)).toFixed(2);
      } else {
        row.Price = dis
          ? (row.Offer * (dis / 100) * (1 + rate / 100)).toFixed(2)
          : (row.Offer * (1 + rate / 100)).toFixed(2);
      }

      row.Amount = ((row.Price * qua * 100) / 100).toFixed(2);
      row.NoTaxAmount = (row.Offer * (dis / 100) * row.Quantity1).toFixed(2);
      row.NoTaxPrice = dis ? (row.Offer * (dis / 100)).toFixed(2) : row.Offer;
      row.TaxAmount =
        ((qua * ((row.NoTaxPrice * (rate * 10)) / 1000) * 100) / 100).toFixed(
          2
        ) || 0;
      row.Quantity = (1 / row.Rate1) * qua;
      if (row.UnitId2 == row.UnitId) {
        row.Quantity2 = row.Quantity;
      } else {
        console.log(row.Rate2, row.Quantity);
        if (!row.Rate2) {
          row.Quantity2 = 0;
        } else {
          row.Quantity2 = row.Rate2 * row.Quantity;
        }
      }
      // row.GrossProfit = row.Amount - (qua * ref)
      this.subTable();
    },
    subTable() {
      this.$emit("getList", this.tableData.concat(this.tableDel));
    },
  },
};
</script>

<style>
.el-link {
  font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
